import {DocumentPreview} from "@/components/ui/forms/DocumentPreview";

import {capitalize} from "@helpers";
import {useLevelOrder} from "@hooks/LevelOrder";
import {ControlButton} from "@ui/buttons/ControlButton";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {SmallDesc} from "@ui/descriptions/SmallDesc";
import {useTranslation} from "react-i18next";
import {v4 as uuidv4} from "uuid";

import styles from "./styles.module.scss";

export const LevelDocuments = ({
  level,
  files,
  onRemoveFile,
  onUploadFile,
  editable = false,
}) => {
  const {scenarioLevels, productLevels, certificationLevels} = useLevelOrder();
  const {t} = useTranslation();

  const currentLevel =
    scenarioLevels.find((l) => l.value === level) ||
    productLevels.find((l) => l.value === level) ||
    certificationLevels.find((l) => l.value === level);

  return (
    <div className={styles.productLevel}>
      <RootDesc>
        <b className={"block w-[200rem]"}>
          {currentLevel ? capitalize(currentLevel?.name) : capitalize(level)}{" "}
          {t("input.level")}
          {level === "easy" && <sup>*</sup>}
        </b>
      </RootDesc>

      <div className={styles.productDocuments}>
        {editable ? (
          <>
            {files && files.length > 0 ? (
              files.map((file) => (
                <div key={uuidv4()}>
                  <DocumentPreview
                    level={level}
                    name={file?.file?.name}
                    onClickCross={(name, level) => onRemoveFile(name, level)}
                  />
                </div>
              ))
            ) : (
              <RootDesc>
                <span>-</span>
              </RootDesc>
            )}

            <ControlButton
              color={"var(--violetLight)"}
              txt={t("button.upload_doc")}
              onClick={() => onUploadFile(level)}
            />
          </>
        ) : files && files.length > 0 ? (
          files.map((file) => (
            <div key={file.id}>
              <SmallDesc>
                <span className={styles.plateDocument}>
                  {file.metadata?.filename}
                </span>
              </SmallDesc>
            </div>
          ))
        ) : (
          <RootDesc>
            <span>-</span>
          </RootDesc>
        )}
      </div>
    </div>
  );
};
